export const getUrlParams = (href) => {
  // 同时能解析标准路由和小程序路由 https://bip-test.yonyoucloud.com/mdf-node/fragment/xxxxx?xxxx=xxxx、file://xxxxxxx#/fragment/xxxxx?xxxx=xxxx、file://xxxxxxx?xxxx=xxxx#/fragment/xxxxx
  let res = {};
  let serach = href.split("?").pop();
  // 兼容处理file://xxxxxxx?xxxx=xxxx#/fragment/xxxxx这种情况
  if (href.startsWith("file:") && serach.indexOf('#/fragment/') > 0) {
    serach = serach.split('#/fragment/')[0]
  }
  console.log('=====================getUrlParams', href)
  let str = decodeURIComponent(serach);
  str = str.trim().replace(/^[?#&]/, "");

  if (!str) {
    return res;
  }
  str.split("&").forEach((strItem) => {
    if (strItem) {
      let parts = strItem.split("=");
      let partKey = parts[0],
        partValue = parts[1] || "";
      res[partKey] = partValue;
    }
  });
  return res;
};

export const getBillNoByPath = (href) => {
  // 同时能解析标准路由和小程序路由 https://bip-test.yonyoucloud.com/mdf-node/fragment/xxxxx?xxxx=xxxx、file://xxxxxxx#/fragment/xxxxx?xxxx=xxxx、file://xxxxxxx?xxxx=xxxx#/fragment/xxxxx
  let billNo = href.split('/fragment/')[1]
  if (billNo.indexOf('?') > 0) {
    billNo = billNo.split('?')[0]
  }
  return billNo
}

export const info = async function (...args) {
  const params = {
    content: args[0],
    color: 'info'
  }
  message(params)
}

export const err = async function (...args) {
  const params = {
    content: args[0],
    color: 'danger',
    duration: null
  }
  message(params)
}

export const message = async function (params) {
  if (window['TinperM']) {
    window['TinperM'].Toast.show(params)
  } else if (TinperNext) {
    TinperNext.Message.create(params)
  }
}

export function isJDiwork() {
  let isJDiworkFlag = false;
  try {
    isJDiworkFlag = window.jDiwork && (window.name === '_WORKBENCH_' || window.parent.name === '_WORKBENCH_' || window.parent.parent.name === '_WORKBENCH_' || window.parent.parent.parent.name === '_WORKBENCH_')
  } catch (error) {
    console.log("Get jDiwork error", error);
  }
  return isJDiworkFlag
}

const scriptLoaded = {}
const cached = {

}
export function loadScript(src, options = {}) {
  if (!src) return

  const { useCache = true } = options
  let promise
  if (useCache) {
    if (cached[src]) {
      return cached[src]
    }
  }

  if (options?.loader === 'AMD') {
    promise = new Promise((resolve, reject) => {
      window.require(
        [src],
        resolve,
        reject
      )
    })
  } else {
    promise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = src
      script.onload = () => {
        resolve()
        scriptLoaded[src] = true
      }
      script.onerror = e => {
        reject(e)
      }
      document.body.appendChild(script)
    })
  }
  if (useCache) {
    cached[src] = promise
  }
  promise.catch(err => {
    console.info(`资源加载失败:${src}`, err)
  })
  return promise
}

export function uuid(len, radix) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuidAns = [];
  const radixFoo = radix || chars.length;

  if (len) {
    for (let i = 0; i < len; i += 1) {
      uuidAns[i] = chars[0 | Math.random() * radixFoo];
    }
  } else {
    let r;
    uuidAns[8] = uuidAns[13] = uuidAns[18] = uuidAns[23] = '-';
    uuidAns[14] = '4';
    for (let i = 0; i < 36; i += 1) {
      if (!uuidAns[i]) {
        r = 0 | Math.random() * 16;
        uuidAns[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuidAns.join('');
}
export function getContext(){
  let context = window.diworkContext ? window.diworkContext() : window.__INITIAL_STATE__?.__GLOBALZITION__
  return context || {}
}
// 获取多语开关
export function isMultilingualFlag() {
  const context = getContext()
  return typeof context?.ext?.multilingualFlag === 'boolean' ? context?.ext?.multilingualFlag : context?.tenant?.multilingualFlag
}

// 获取当前语种
export function getMultiLocale() {
  const context = getContext()
  return context?.locale
}

// 关闭节点
export function closeWin() {
  try {
    if (window.mtl) {
      window.closeYnfBill?.()
      window.mtl.navigateBack();
    } else if (isJDiwork()) {
      window.jDiwork.closeWin();
    } else {
      window.close();
    }
  } catch (err) {
    console.log(err);
  }
}

/**
 * 判断document.title是否可修改，因为工作台里document.title修改会报错，如果可修改，就修改页签标题
 * @param {*} title
 */
export function setTitleToDocument(title) {
  if (!Object.getOwnPropertyDescriptor(document, 'title') || (Object.getOwnPropertyDescriptor(document, 'title').configurable && Object.getOwnPropertyDescriptor(document, 'title').writable)) {
    document.title = title;
  }
}

export function isObjectEmpty(obj) {
  return typeof obj != 'object' || obj === undefined || obj === null || Object.keys(obj).length === 0;
}
